export const ContactSendMessageComponent = {
	bindings: {
		onMessage: '&'
	},
	templateUrl: 'contact-message-button.html',
	controller: class ContactSendMessageComponent {
		constructor($mdDialog, CommonConstants, $timeout, messagingService, $rootScope, notificationService, captchaService) {
			'ngInject';
			this.$mdDialog = $mdDialog;
			this.messagingService = messagingService;
			this.$timeout = $timeout;
			this.emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			this.numberRegex = /^\d+$/;
			this.model = {};
			this.showRecaptcha = true;
			this.CommonConstants = CommonConstants;
			this.$rootScope = $rootScope;
			this.$rootScope.globalNotification = {};
			this.notificationService = notificationService;
			this.captchaService = captchaService;
		}

		$onChanges(changes) {
			if (changes.formError && !changes.formError.isFirstChange()) {
				this.backendError = angular.copy(this.formError);
				if (this.backendError == 'success') {
					this.$mdDialog.cancel();
				}
			}
		}
		resetCaptchaError() {
			this.agentMessageForm.captcha.$setValidity('invalid', true, this.agentMessageForm)
		}
		openMessageForm() {
			const vm = this;
			this.$mdDialog.show({
				templateUrl: 'general-message-form.html',
				clickOutsideToClose: true,
				controller: () => this,
				controllerAs: '$ctrl',
				onComplete() {
					vm.captchaText = null;
					vm.initCaptcha();
				}
			});
		}

		closeMessageForm() {
			this.model = {};
			this.$mdDialog.hide();
			this.$rootScope.globalNotification = {};
		}

		initCaptcha() {
			this.captchaService.getCaptcha().then(
				response => {
					this.captchaId = response.data.captchaId;
					this.captchaImg = response.data.htmlFragment;
				},
				error => {
					window.ipEventBus.publish('show-error', {
						message: 'technicalError'
					});
				}
			);
		}

		send() {
			this.messagingService.sendGeneralMessage(this.model, {captchaId: this.captchaId, captchaText: this.captchaText}).then((response) => {
				this.$rootScope.globalNotification = {
					message: 'successShareNotification'
				};
			}).catch((error) => {
				if (error.status == 400 && error.data?.error == 'captcha') {
					this.agentMessageForm.captcha.$setValidity('invalid', false, this.agentMessageForm)
					this.agentMessageForm.captcha.$setPristine();
					this.agentMessageForm.captcha.$setUntouched();
					this.captchaText = null;
					this.initCaptcha();
				} else {
					this.notificationService.showError({
						message: 'technicalError'
					});
				}
			});
		}

	}
};
